<template>
    <!--  Modal -->
    <v-dialog persistent :value="addModal" width="800">
      <popup-heading 
      title="CREATE A ROLE" 
      subtitle="Create a role that can be assigned to a user.">
        <template slot="action">
          <v-btn
            @click="closeModal()"
            depressed
            fab 
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
          >
            <v-icon dark class="primary--text">close</v-icon>
          </v-btn>

          <v-btn
            v-if="addRoleStep == '3'" 
            depressed
            @click="addPermissionToRole()"
            fab 
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-0' : 'ml-0'"
          >
            <v-icon dark class="primary--text">check</v-icon>
          </v-btn>
        </template>
      </popup-heading>

    
      <v-card class="elevation-0">
        <v-layout  justify-center>

            <!--- Step 1-->
            <v-flex :class="addRoleStep == '1' ? 'sm12 md8 lg8' : 'sm12 md12 lg12'">
              <v-card class="elevation-0" v-if="addRoleStep == '1'">
                <v-card-text>
                  <v-form ref="addForm" lazy-validation>

                    <v-flex xs12 class="mb-4 pt-4">
                      <p class="mb-0 font-weight-bold headline">Name:</p>
                      <v-text-field
                        class="pt-0 input-text-center"
                        v-model="form.name"
                        :rules="fieldRequired"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                      <p class="mb-0 font-weight-bold headline">Description:</p>
                      <v-text-field
                        class="pt-0 input-text-center"
                        v-model="form.description"
                        :rules="fieldRequired"
                      ></v-text-field>
                    </v-flex>

                  </v-form>
                </v-card-text>
              </v-card>
              <!--- Step 1 ends -->

              <!-- step 2 -->
              <v-card class="elevation-0" v-if="addRoleStep == '2'">
                <v-card-text>
            
                  <h3 class="font-weight-regular display-1 my-3">SELECT AN APP</h3>

                  <v-layout column>
                    <v-flex sm12 md12>
                      <v-text-field
                        class="search-input"
                        v-model="searchApp"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-flex>

                    <v-flex sm12 md12>
                      <div class="text-center">
                        <v-pagination :total-visible="10" :circle="true"  v-model="page" :length="pageCount"></v-pagination>
                      </div>
                      <v-data-table
                        :headers="appTableHeaders"
                        :items="loggedInBusinessApps"
                        :search="searchApp"
                        class="pb-4 tabulardata"
                        :page.sync="page"
                        :items-per-page="itemsPerPage"
                        hide-default-footer
                        @page-count="pageCount = $event"
                      >
                        <template v-slot:body="{ items }">
                          <tbody>
                            <tr v-for="(item,index) in items" :key="'role-app-list' + index">
                            <td class="text-left">{{ item.name }}</td>
                            <td class="text-right">
                              <v-btn
                                @click="getResourcesOfSelectedApp(item)"
                                slot="activator"
                                fab 
                                small
                                dark 
                                color="primary"
                                :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-3 xs-small' : 'ml-3 xs-small'"
                              >
                                <v-icon dark>fas fa-long-arrow-alt-right</v-icon>
                              </v-btn>
                            </td>
                            </tr>
                          </tbody>
                        </template>
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                          No results.
                        </v-alert>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                
                </v-card-text>
              </v-card>
              <!-- setp 2 ends -->


              <!-- step 3 -->
              <v-card class="elevation-0" v-if="addRoleStep == '3'">
                <v-card-text>
                  <h3 class="font-weight-regular display-1 my-3">SET THE PERMISSION</h3>
                  <div class="text-center">
                    <v-pagination :total-visible="10" :circle="true"  v-model="pagePermission" :length="pageCount"></v-pagination>
                  </div>
     
                  <v-data-table
                    :hide-default-header="true"
                    :headers="permissionTableHeaders"
                    :items="selectedAppResources"
                    :search="searchPermission"
                    class="pb-4 tabulardata permission-table remove-hover"
                    :page.sync="pagePermission"
                    :items-per-page="itemsPerPage"
                    hide-default-footer
                    @page-count="pageCount = $event"
                  >
                    <template v-slot:body="{ items }">
                      <tbody>
                        <tr v-for="(item,index) in items" :key="'role-permission-list' + index">
                          <td class="pr-0">
                            <v-checkbox v-on:change="mainParentChecked($event, item.my_index)" class="tbl-chekbox mr-0 pr-0" color="primary" :label="item.display_name ? item.display_name : item.name" v-model="item.checked"></v-checkbox> 
                            <span :class="item.open ? 'toggle-icon revert' : 'toggle-icon'" @click.prevent="item.open = !item.open"><i class="fas fa-angle-down"></i></span>
                            <div class="item-atrs" v-show="item.open">
                              <ul>
                                <li v-bind:key="'perm-' + key " v-for="(permission, key) in item.permissions"> 
                                  <v-checkbox class="tbl-chekbox mr-0 pr-0" color="primary" v-on:change="permissionChecked($event, item.my_index, 'null', 'null', 'null')" :label="key" v-model="item.permissions[key]"></v-checkbox>
                                </li>
                              </ul>
                            </div>

                            <template v-if="item.sub_resources && item.sub_resources.length > 0">
                                <table width="100%" class="nested-table" v-show="item.open">
                                  <tr v-bind:key="'key-' + key" v-for="(innerItem, key) in item.sub_resources">
                                    <td>
                                      <v-checkbox class="tbl-chekbox mr-0 pr-0" v-on:change="subParentChecked($event, item.my_index,  innerItem.my_index)" color="primary" :label="innerItem.display_name ? innerItem.display_name : innerItem.name " v-model="item.sub_resources[key].checked"></v-checkbox> 
                                      <span :class="innerItem.open ? 'toggle-icon revert' : 'toggle-icon'" @click.prevent="innerItem.open = !innerItem.open"><i class="fas fa-angle-down"></i></span> 
                                      <div class="item-atrs" v-show="innerItem.open">
                                          <ul>
                                            <li v-bind:key="'perminner-' + innerPermissionKey " v-for="(innerPermission, innerPermissionKey) in item.sub_resources[key].permissions"> 
                                              <v-checkbox class="tbl-chekbox mr-0 pr-0" color="primary" v-on:change="permissionChecked($event, item.my_index, innerItem.my_index, 'null', 'null')" :label="innerPermissionKey" v-model="item.sub_resources[key].permissions[innerPermissionKey]"> </v-checkbox>
                                            </li>
                                          </ul>
                                        </div>
                                        <!-- Second child -->
                                        <template v-if="innerItem.sub_resources.length > 0">
                                          <table width="100%" class="nested-table" v-show="innerItem.open">
                                              <tr v-bind:key="'innerkey-' + innerkey" v-for="(innerInnerItem, innerkey) in innerItem.sub_resources">
                                                <td>
                                                  <v-checkbox class="tbl-chekbox mr-0 pr-0" color="primary" v-on:change="subSubParentChecked($event, item.my_index, innerItem.my_index, innerInnerItem.my_index)" :label="innerInnerItem.display_name ? innerInnerItem.display_name : innerInnerItem.name" v-model="item.sub_resources[key].sub_resources[innerkey].checked"></v-checkbox> 
                                                  <span :class="innerInnerItem.open ? 'toggle-icon revert' : 'toggle-icon'" @click.prevent="innerInnerItem.open = !innerInnerItem.open"><i class="fas fa-angle-down"></i></span> 
                                                  <div class="item-atrs" v-show="innerInnerItem.open">
                                                    <ul>
                                                      <li v-bind:key="'perminner-' + innerInnerPermissionKey " v-for="(innerPermission, innerInnerPermissionKey) in item.sub_resources[key].sub_resources[innerkey].permissions"> 
                                                        <v-checkbox class="tbl-chekbox mr-0 pr-0" color="primary" v-on:change="permissionChecked($event, item.my_index, innerItem.my_index, innerInnerItem.my_index, 'null')"  :label="innerInnerPermissionKey" v-model="item.sub_resources[key].sub_resources[innerkey].permissions[innerInnerPermissionKey]"> </v-checkbox>
                                                      </li>
                                                    </ul>
                                                  </div>

                                                  <!-- Grand child  -->
                                                  <template  v-if="innerInnerItem.sub_resources.length > 0">
                                                      <table width="100%" class="nested-table" v-show="innerInnerItem.open">
                                                        <tr v-bind:key="'innerkey-' + thirdLevelInnerkey" v-for="(thirdLevelInnerIterm, thirdLevelInnerkey) in innerInnerItem.sub_resources">
                                                          <td>
                                                            <v-checkbox class="tbl-chekbox mr-0 pr-0" color="primary" v-on:change="subSubSubParentChecked($event, item.my_index, innerItem.my_index, innerInnerItem.my_index, thirdLevelInnerIterm.my_index)" :label="thirdLevelInnerIterm.display_name ? thirdLevelInnerIterm.display_name : thirdLevelInnerIterm.name" v-model="item.sub_resources[key].sub_resources[innerkey].sub_resources[thirdLevelInnerkey].checked"></v-checkbox>
                                                            <span :class="thirdLevelInnerIterm.open ? 'toggle-icon revert' : 'toggle-icon'" @click.prevent="thirdLevelInnerIterm.open = !thirdLevelInnerIterm.open"><i class="fas fa-angle-down"></i></span> 
                                                            <div class="item-atrs" v-show="thirdLevelInnerIterm.open">
                                                              <ul>
                                                                <li v-bind:key="'perminner-' + thirdLevelInnerPermissionKey " v-for="(thirdLevelInnerItermPermission, thirdLevelInnerPermissionKey) in item.sub_resources[key].sub_resources[innerkey].sub_resources[thirdLevelInnerkey].permissions"> 
                                                                  <v-checkbox class="tbl-chekbox mr-0 pr-0" color="primary" v-on:change="permissionChecked($event, item.my_index, innerItem.my_index, innerInnerItem.my_index, thirdLevelInnerPermissionKey)"  :label="thirdLevelInnerPermissionKey" v-model="item.sub_resources[key].sub_resources[innerkey].sub_resources[thirdLevelInnerkey].permissions[thirdLevelInnerPermissionKey]"> </v-checkbox>
                                                                </li>
                                                              </ul>
                                                            </div>
                                                          </td>
                                                        </tr>
                                                      </table>
                                                  </template>
                                                </td>
                                              </tr>
                                          </table>
                                        </template>
                                    </td>
                                  </tr>
                                </table>
                            </template>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                      No results.
                    </v-alert>
                  </v-data-table>
                  <div class="px-3 pb-3 text-left" v-if="addRoleStep == 3">
                    <v-btn
                      color="primary"
                      fab
                      medium
                      @click="backtoStep2()"
                    >
                      <v-icon dark>fas fa-long-arrow-alt-left</v-icon>
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
              <!-- setp 3 ends -->


             <!-- step 4 -->
              <v-card class="elevation-0" v-if="addRoleStep == '4'">
                <v-card-text>
                  <h2 class="mb-5 display-1 text-cs-center primary--color font-weight-bold">SUCCESS</h2>
                  <h2 class="text-cs-center display-1 primary--color font-weight-bold">{{ this.currentlyCreatedRoleObj.name }}</h2>
                  <h4 class="font-weight-bold">HAS BEEN SUCCESSFULLY CREATED!</h4>

                  <v-layout row wrap class="mt-8">
                    <v-flex sm12 md6 class="px-4">
                      <v-btn @click="reCreate()" color="primary" block class="font-weight-medium">CREATE NEW ROLE</v-btn>
                    </v-flex>
                    <v-flex sm12 md6 class="px-4">
                      <v-btn @click="closeModal()" color="primary" block class="font-weight-medium">ALL DONE</v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <!-- setp 4 ends -->
          </v-flex>
        </v-layout>
        

        <!-- Setp actions -->
        <div class="px-3 pb-3 text-xs-left text-md-right">
          <v-btn
            v-if="addRoleStep == '1'" 
            color="primary"
            fab
            medium
            @click="addNewRole()"
          >
            <v-icon dark>fas fa-long-arrow-alt-right</v-icon>
          </v-btn>
        </div>
        <!-- Setp actions ends -->
        
      </v-card>
    </v-dialog>

</template>
<script>
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import Helper from '@/components/Controllers/Helpers';
import { mapActions, mapGetters } from 'vuex';
import { size, pick } from 'lodash';

export default {
  data() {
    return {
      bulk: {
        label: 'Select All',
        value: 0,
      },
      page: 1,
      pagePermission: 1,
      pageCount: 0,
      itemsPerPage: 10,
      searchApp: '',
      appTableHeaders: [
        { text: 'Name', value: 'name', sortable: false, class: 'font-weight-bold' },
        { text: '', value: '', sortable: false, class: 'font-weight-bold' },
      ],
      
      searchPermission: '',
      permissionTableHeaders: [
        { text: 'Name', value: 'name', sortable: false, class: 'font-weight-bold' },
      ],
      permissionTableItems: [],

      urlValidation: [
        v => !!v || 'Field is required',
        v =>
          /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/.test(v) || 'Invalid url',
      ],
      fieldRequired: [
        v => !!v || 'Field is required.',
      ],
      addRoleStep: '1',

      form: {
        name: '',
        description: '',
      },
     
      currentlyCreatedRoleObj: {},
      selectedAppObj: {},
      loggedInBusinessApps: [],
      selectedAppResources: [],
    };
  },
  computed: {
  
    appTableItems() {
       return this.applicationList;
    },

    selectableAppList() {
      return Helper.getSelectableValue(this.applicationList, 'name', 'id');
    },

    ...mapGetters({
      addModal: 'role/add',
      businessRolesList: 'role/businessList',
      applicationList: 'application/list',
    }),
  },
  
  mounted() {
    this.closeModal();
  },

  methods: {
    mainParentChecked(e, parentIndex) {

      let checkedSts = e ? true : false;
      // Top level permissions
      for(let key in this.selectedAppResources[parentIndex].permissions){
        this.selectedAppResources[parentIndex].permissions[key] = checkedSts;
      }
      // Parent child, 1 level
      this.selectedAppResources[parentIndex].sub_resources.map(item => {
        item.checked = checkedSts;
        for(let key in item.permissions){
          item.permissions[key] = checkedSts;
        }
        // First child, 2 level
        if(item.hasOwnProperty('sub_resources')){
          var innerRawData = item.sub_resources;
          innerRawData.map(innerItem => {
            
            innerItem.checked = checkedSts;
            for(let key in innerItem.permissions){
              innerItem.permissions[key] = checkedSts;
            }
            // Second child, 3 level
            if(innerItem.hasOwnProperty('sub_resources')){
              var innerInnerRawData = innerItem.sub_resources;
              innerInnerRawData.map(itemInneritem => {

                itemInneritem.checked = checkedSts;
                for(let key in innerInnerRawData.permissions){
                  innerInnerRawData.permissions[key] = checkedSts;
                }
                // Third child, 4 level 
                if(itemInneritem.hasOwnProperty('sub_resources')){
                  var thirdLevelRawData = itemInneritem.sub_resources;
                  innerInnerRawData.map(thirdLevelItem => {

                      thirdLevelItem.checked = checkedSts;
                      for(let key in thirdLevelItem.permissions){
                        thirdLevelItem.permissions[key] = checkedSts;
                      }
                  })
                }
              })
            }
          })
        }
      })
    },

     /**
     * Make  parent checked if sub child are checked
     */
    subParentChecked(e, parentIndex, childIndex) {
   
      let checkedSts = e ? true : false;
      for(let key in this.selectedAppResources[parentIndex].sub_resources[childIndex].permissions){
        this.selectedAppResources[parentIndex].sub_resources[childIndex].permissions[key] = checkedSts;
      }
      // Second child, level 3
      this.selectedAppResources[parentIndex].sub_resources[childIndex].sub_resources.map(item => {
        item.checked = checkedSts;
        for(let key in item.permissions){
          item.permissions[key] = checkedSts;
        }
         // Third child, level 4
        if(item.hasOwnProperty('sub_resources')){
          var thirdLevelRawData = item.sub_resources;
          thirdLevelRawData.map(thirdLevelItem => {
            thirdLevelItem.checked = checkedSts;
            for(let key in thirdLevelItem.permissions){
              thirdLevelItem.permissions[key] = checkedSts;
            }
          })
        }
      });
      // After we make checked
       if(e){
        // This works for main parent, if all child are checked make parent check
        let totalSiblings = this.selectedAppResources[parentIndex].sub_resources.length;
        // Nou count no of items which as checked value
        let arrOfCheckedItems = this.selectedAppResources[parentIndex].sub_resources.filter(item => item.checked );
        if(totalSiblings == arrOfCheckedItems.length) {
          this.selectedAppResources[parentIndex].checked = true;
        }
      } 
    },

    /**
     * Make sub parent checked if lower last all child are checked
     */
    subSubParentChecked(e, parentIndex, subParentIndex, subSubParentIndex ){
      let checkedSts = e ? true : false;
      // For same level 
      for(let key in this.selectedAppResources[parentIndex].sub_resources[subParentIndex].sub_resources[subSubParentIndex].permissions){
        this.selectedAppResources[parentIndex].sub_resources[subParentIndex].sub_resources[subSubParentIndex].permissions[key] = checkedSts;
      }
      this.selectedAppResources[parentIndex].sub_resources[subParentIndex].sub_resources[subSubParentIndex].sub_resources.map(item => {
        item.checked = checkedSts;
        for(let key in item.permissions){
          item.permissions[key] = checkedSts;
        }
      });
  
      if(e){
        // This works for main parent, if all child are checked make parent check
        let totalSiblings = this.selectedAppResources[parentIndex].sub_resources[subParentIndex].sub_resources.length;
        // Nou count no of items which as checked value
        let arrOfCheckedItems = this.selectedAppResources[parentIndex].sub_resources[subParentIndex].sub_resources.filter(item => item.checked );
        if(totalSiblings == arrOfCheckedItems.length) {
          this.selectedAppResources[parentIndex].sub_resources[subParentIndex].checked = true;
          // There might be case, when last child are checked equal to all checked 
          this.subParentChecked(true,parentIndex, subParentIndex )
        }
      } 
    },

     /**
     * Make sub sub sub parent (last parent) checked if lower last all child are checked
     */
    subSubSubParentChecked(e, parentIndex, subParentIndex, subSubParentIndex, thirdLevelInnerkey ){
      let checkedSts = e ? true : false;
      // For same level 
      for(let key in this.selectedAppResources[parentIndex].sub_resources[subParentIndex].sub_resources[subSubParentIndex].sub_resources[thirdLevelInnerkey].permissions){
        this.selectedAppResources[parentIndex].sub_resources[subParentIndex].sub_resources[subSubParentIndex].sub_resources[thirdLevelInnerkey].permissions[key] = checkedSts;
      }
    },

    /**
     * On permission checked 
     */
    permissionChecked(e, parentIndex, subParentIndex, subSubParentIndex, thirdParentIndex){
      
      if(thirdParentIndex != 'null') {

        // This Third level checkbox
        let obj =  this.selectedAppResources[parentIndex].sub_resources[subParentIndex].sub_resources[subSubParentIndex].sub_resources[thirdParentIndex].permissions;
        let totalPermissionList = _.size(obj);
        // Now we need to get length of checked ones 
        let checkedPermissionsCount = 0;
        for(let key in obj){
          if(obj[key] === true){
            checkedPermissionsCount++;
          }
        }
        if(checkedPermissionsCount == totalPermissionList){
          this.selectedAppResources[parentIndex].sub_resources[subParentIndex].sub_resources[subSubParentIndex].sub_resources[thirdParentIndex].checked = true;
        }
      } else if(subSubParentIndex != 'null'){

        // Second level checkbox
        let obj =   this.selectedAppResources[parentIndex].sub_resources[subParentIndex].sub_resources[subSubParentIndex].permissions;
        let totalPermissionList = _.size(obj);
        // Now we need to get length of checked ones 
        let checkedPermissionsCount = 0;
        for(let key in obj){
          if(obj[key] === true){
            checkedPermissionsCount++;
          }
        }
        if(checkedPermissionsCount == totalPermissionList){
          this.selectedAppResources[parentIndex].sub_resources[subParentIndex].sub_resources[subSubParentIndex].checked = true;
        }
      } else if (subParentIndex != 'null'){

         // First level
        let noOfInnerResources = this.selectedAppResources[parentIndex].sub_resources[subParentIndex].sub_resources.length; 
        if(noOfInnerResources < 1){
          let obj =   this.selectedAppResources[parentIndex].sub_resources[subParentIndex].permissions;
          let totalPermissionList = _.size(obj);
          let checkedPermissionsCount = 0;
          for(let key in obj){
            if(obj[key] === true){
              checkedPermissionsCount++;
            }
          }
          if(checkedPermissionsCount == totalPermissionList){
            this.selectedAppResources[parentIndex].sub_resources[subParentIndex].checked = true;
          }
        }

      } else if (parentIndex != 'null'){
        // Main parent
        let noOfInnerresources = this.selectedAppResources[parentIndex].sub_resources.length; 
        if(noOfInnerresources < 1){
          let obj =   this.selectedAppResources[parentIndex].permissions;
          let totalPermissionList = _.size(obj);
          let checkedPermissionsCount = 0;
          for(let key in obj){
            if(obj[key] === true){
              checkedPermissionsCount++;
            }
          }
          if(checkedPermissionsCount == totalPermissionList){
            this.selectedAppResources[parentIndex].checked = true;
          }
        }
      }
    },

    /**
    *  Fetch all business roles
    */
    fetchRoles() {  
      const url = `${Env.url}/api/v1/roles`;
      AuthApi.getApi(url)
      .then((res) => {
        this.setList(res.data.payload);
      })
      .catch((err) => {
        console.log('Unable to fetch roles');
      });
    },

    /**
     * Add new role, just validate form
     */
    addNewRole() {
      if (this.$refs.addForm.validate()) {
        this.spinner(true);
        const url = `${Env.url}/api/v1/roles`;
        AuthApi.postApi(url, {
            name: this.form.name,
            desc: this.form.description,
          }
        )
        .then((res) => {
          this.currentlyCreatedRoleObj = res.data.payload;
          this.snackbar({
            text: res.data.msg,
            timeout: 4000,
            open: true,
          });
           // Reset form as soon as it creates
          //this.form = Helper.setObjValueEmpty(this.form);
          
          this.$refs.addForm.reset();

          this.fetchRoles();
          this.fetchCurrentLoggedInBusinessApps();

        })
        .catch((err) => {
          this.spinner(false);
          this.snackbar({
            text: err.response.data.msg,
            timeout: 4000,
            open: true,
          });
        });
      }
    },


    /**
     * Current logged in business apps
     */
    fetchCurrentLoggedInBusinessApps() {
      const url = `${Env.url}/api/v1/businesses/${ this.$store.getters.getLoggedInUserSelectedBusinessId}/apps`;
      AuthApi.getApi(url)
        .then((res) => {
          this.loggedInBusinessApps = res.data.payload;
          this.spinner(false);
          this.addRoleStep = 2;
        })
        .catch((err) => {
          this.spinner(false);
            console.log('Unable to fetch logged in user business apps.')
        });
    },

    /**
     * Select the app
     */
    getResourcesOfSelectedApp(obj) { 

      this.selectedAppObj = obj;
      this.spinner(true);
      const url = `${Env.url}/api/v1/apps/${ obj.id }/resources`;
      AuthApi.getApi(url)
        .then((res) => {
        //  this.selectedAppResources = res.data.payload; sub_resources
          var rawData =  res.data.payload;
          rawData.map((item, itemKey )=> {
            item.my_index = itemKey;
            item.checked = false;
            item.open = false;
            item.permissions = {
              create: false,
              read: false,
              update: false,
              delete: false,
              approval: false,
            };

              // Inner child 
              if(item.hasOwnProperty('sub_resources')){
                // the sub exist 
                var innerRawData = item.sub_resources;
                  innerRawData.map((innerItem, innerItemIndex) => {
                    innerItem.my_index = innerItemIndex;
                    innerItem.open = false;
                    innerItem.checked = false;
                    innerItem.permissions = {
                      create: false,
                      read: false,
                      update: false,
                      delete: false,
                      approval: false,
                    };
                      // check second innter 
                      if(innerItem.hasOwnProperty('sub_resources')){
                        var innerInnerRawData = innerItem.sub_resources;
                        innerInnerRawData.map((innerInnerItem, innerInnerItemIndex) => {
                          innerInnerItem.my_index = innerInnerItemIndex;
                          innerInnerItem.open = false;
                          innerInnerItem.checked = false;
                          innerInnerItem.permissions = {
                            create: false,
                            read: false,
                            update: false,
                            delete: false,
                            approval: false,
                          };

                            if(innerInnerItem.hasOwnProperty('sub_resources')){
                              var deepInnerRawData = innerInnerItem.sub_resources;
                              deepInnerRawData.map((deepInnerItem, deepInnerItemIndex) => {
                                deepInnerItem.my_index = deepInnerItemIndex;
                                deepInnerItem.open = false;
                                deepInnerItem.checked = false;
                                deepInnerItem.permissions = {
                                  create: false,
                                  read: false,
                                  update: false,
                                  delete: false,
                                  approval: false,
                                };
                              })
                            }
                        })
                      }
                  })
              }
          })
          this.selectedAppResources = rawData;
          this.spinner(false);
          this.addRoleStep = 3;
        })
        .catch((err) => {
          this.spinner(false);
          this.snackbar({
            text: err.response.data.msg,
            timeout: 4000,
            open: true,
          });
          console.log('Unable to fetch selected app resources.')
        });
    },

    backtoStep2() {
      this.selectedAppResources = [];
      this.addRoleStep = 2;
    },

    /**
     * Add permission on role
     */

    addPermissionToRole() {
      this.spinner(true);
      // Now collect available datas
      let data = {
        'permissions': [],
      }

      // Need to do 3 level foreach to get all selected ids 
      this.selectedAppResources.map(item => {
        // First level
        let obj = _.assign({}, { app_resource: item.id }, item.permissions);
        data.permissions.push(obj);
        // Level 2
        if(item.hasOwnProperty('sub_resources')){
          let innerRawData = item.sub_resources;
            innerRawData.map(innerItems => {
              let obj = _.assign({}, { app_resource: innerItems.id }, innerItems.permissions);
              data.permissions.push(obj);
              // Level 3
                 if(innerItems.hasOwnProperty('sub_resources')){
                    let innerInnerRawData = innerItems.sub_resources;
                    innerInnerRawData.map(innerInnerItems => {
                        let obj = _.assign({}, { app_resource: innerInnerItems.id }, innerInnerItems.permissions);
                        data.permissions.push(obj);
                        // Level 4
                        // Grand child third child, 4th level 
                        if(innerInnerItems.hasOwnProperty('sub_resources')){
                          let deepInnerRawData = innerInnerItems.sub_resources;
                          deepInnerRawData.map(deepInnerItems => {
                              let obj = _.assign({}, { app_resource: deepInnerItems.id }, deepInnerItems.permissions);
                              data.permissions.push(obj);
                          })
                        }

                    })
                 }
            })
        }
      }) 


      //Hit api
       const url = `${Env.url}/api/v1/roles/${this.currentlyCreatedRoleObj.id}/permissions/${this.selectedAppObj.id}`;
      AuthApi.postApi(url, data)
      .then((res) => {
        this.snackbar({
          text: res.data.msg,
          timeout: 4000,
          open: true,
        });
        this.spinner(false);
        this.addRoleStep = '4';
      })
      .catch((err) => {
        this.spinner(false);
        this.snackbar({
          text: err.response.data.msg,
          timeout: 4000,
          open: true,
        });
      });
    },

    reCreate() {
      this.form = Helper.setObjValueEmpty(this.form);
       this.addRoleStep = '1';
       this.currentlyCreatedRoleObj = {};
       this.selectedAppObj = {};
    },
    /**
     * Close update modal and remove assign values in form
     */
    closeModal() {
      if(this.addRoleStep == 1){
        this.$refs.addForm.reset();
      }
      // Rest form values
      this.fetchRoles();  
      this.form = Helper.setObjValueEmpty(this.form);
      this.setAdd(false);
      this.addRoleStep = '1';
      this.loggedInBusinessApps = [];
      this.currentlyCreatedRoleObj = {};
      this.selectedAppObj = {};
    },


    ...mapActions({
      setAdd: 'role/setAdd',
      setList: 'role/setList',
      spinner: 'spinner/spinnerStatus',
      snackbar: 'snackbar/snackbar',
    }),
  },
};
</script>
